import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const [instructionsOpen, setInstructionsOpen] = useState(true);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();
  const shipping = 9.99;
  const total = subtotal + shipping;

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleRemove = (id, size, color) => {
    removeFromCart(id, size, color);
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page empty">
        <h2>Your cart is empty</h2>
        <Link onClick={toTop} to="/shop" className="continue-shopping">
          Continue Shopping
        </Link>
      </div>
    );
  }

  const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <div className="cart-page main">
      <div className="cart-left">
        <h1 className="cart-title">
          Cart <span className="cart-count">{totalItems}</span>
        </h1>

        <div className="cart-items">
          {cartItems.map((item, index) => {
            const product = getProductById(item.id);
            if (!product) return null;
            return (
              <div key={index} className="cart-item">
                <div className="item-image">
                  <Link onClick={toTop} to={`/shopDetails/${product.id}`}>
                    <img src={product.image} alt={product.name} />
                  </Link>
                </div>
                <div className="item-details">
                  <div className="item-info">
                    <Link
                      onClick={toTop}
                      to={`/shopDetails/${product.id}`}
                      className="item-name"
                    >
                      {product.name.toUpperCase()}
                    </Link>
                    <div className="item-variant">
                      {item.size}, {item.color.toUpperCase()}
                    </div>
                    <div className="item-price">${product.price}</div>
                  </div>

                  <div className="item-actions">
                    <div className="quantity-control">
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity - 1
                          )
                        }
                      >
                        -
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                    <button
                      className="remove-btn"
                      onClick={() =>
                        handleRemove(item.id, item.size, item.color)
                      }
                    >
                      <svg
                        viewBox="0 0 24 24"
                        width="16"
                        height="16"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    </button>
                  </div>

                  <div className="item-total">
                    ${(parseFloat(product.price) * item.quantity).toFixed(2)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="cart-right">
        <div className="order-summary">
          <div className="summary-accordion">
            <button
              className="accordion-header"
              onClick={() => setInstructionsOpen(!instructionsOpen)}
            >
              Special instructions
              <span>{instructionsOpen ? "-" : "+"}</span>
            </button>
            {instructionsOpen && (
              <div className="accordion-content">
                <textarea rows="4"></textarea>
              </div>
            )}
          </div>

          <div className="summary-total">
            <span>Subtotal</span>
            <span className="price">${subtotal.toFixed(2)} USD</span>
          </div>

          <div className="summary-total">
            <span>Shipping</span>
            <span className="price">${shipping.toFixed(2)} USD</span>
          </div>

          <div className="summary-total">
            <span>Estimated total</span>
            <span className="price">${total.toFixed(2)} USD</span>
          </div>

          <p className="taxes-note">
            Flat-rate shipping is included in the estimated total.
          </p>

          <button className="store-pickup-btn" type="button">
            <svg
              viewBox="0 0 24 24"
              width="24"
              height="24"
              stroke="currentColor"
              strokeWidth="1.5"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            Delivery service
          </button>
          <p className="pickup-error">
            Orders are dispatched to the delivery address entered at checkout.
          </p>

          <button className="checkout-btn" onClick={handleCheckout}>
            Check out
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
